import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbsComponent } from './bread-crumbs.component';
import { Router, RouterModule } from '@angular/router';
import { ApplicationPipesModule } from 'src/app/pipe/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';




@NgModule({
  declarations: [
    BreadCrumbsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ApplicationPipesModule,
    MatTooltipModule
  ],
  exports: [
    BreadCrumbsComponent,
  ]
})
export class BreadCrumbsModule { }
